








import {
  defineComponent,
  PropType,
} from '@vue/composition-api';
import type { ContractListItem, ProductItemType } from '@/api/rights/shop-mall/types';
import { CreditMallFromEnum } from '@/api/rights/shop-mall/types';
import CreditPaymentAgreement from './credit-payment-agreement.vue';

export default defineComponent({
  name: 'FqMall',
  components: {
    CreditPaymentAgreement,
  },
  props: {
    contractList: {
      type: Array as PropType<ContractListItem[]>,
      required: true,
    },
    productList: {
      type: Array as PropType<ProductItemType[]>,
      required: true,
    },
    from: {
      type: String,
      default: CreditMallFromEnum.FINANCE_SCREENING_AGREEMENT,
    },
  },
});
